import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'components/FormInputs';
import AcceptanceTermsText from './acceptance-terms-text';

const AcceptedTerms = ({ booking }) => {
  return (
    <>
      <Checkbox
        name="terms"
        onChange={() => {}}
        value
        checked
        disabled
        style={{ paddingLeft: 0 }}
        label={<AcceptanceTermsText booking={booking} />}
      />
    </>
  );
};

AcceptedTerms.propTypes = {
  booking: PropTypes.shape({}).isRequired,
};

export default AcceptedTerms;
